"use client"
import { useTheme } from "@emotion/react"
import styled from "@emotion/styled"
import { NumbersComponent } from "ui"
import { NumbersGridBackgroundProps } from "ui/NumbersComponent/NumbersGrid"

const StyledContainer = styled.div`
  width: 100%;
`

type Props = {
  data: any
  accentColor?: "string"
  hideIndicator?: boolean
  backgroundColors?: NumbersGridBackgroundProps
  showIcons?: boolean
}

export const Numbers: React.FC<Props> = ({ data, backgroundColors, showIcons }) => {
  const theme = useTheme()
  return (
    <StyledContainer>
      <NumbersComponent
        data={data}
        accentColor={"white"}
        backgroundColor={theme.colors.propBlue}
        textColor="white"
        titleColor="white"
        backgroundColors={backgroundColors}
        showIcons={showIcons}
      />
    </StyledContainer>
  )
}
export default Numbers
